/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Create_Team_CreateInputs */



/**
* | output |
* | --- |
* | "Create Team" |
*
* @param {Teams_Create_Team_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_create_team_create = /** @type {((inputs?: Teams_Create_Team_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Create_Team_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team erstellen")
	return /** @type {LocalizedString} */ ("Create Team")
});